module.exports = __webpack_public_path__ + "img/ny_feature.3fa4a3d9.jpg";